// src/hooks/useTheme.js
import { useEffect, useState, createContext, useContext } from 'react';

const ThemeContext = createContext();

/**
 * Provedor de tema global com persistência local e controle dinâmico.
 *
 * @param {object} props
 * @param {JSX.Element} props.children - Componentes filhos da árvore React
 * @returns {JSX.Element}
 */
export const ThemeProvider = ({ children }) => {
  const defaultTheme = 'lumen';
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || defaultTheme);

  useEffect(() => {
    localStorage.setItem('theme', theme);

    const linkId = 'dynamic-theme-link';
    let linkTag = document.getElementById(linkId);

    if (!linkTag) {
      linkTag = document.createElement('link');
      linkTag.id = linkId;
      linkTag.rel = 'stylesheet';
      linkTag.type = 'text/css';
      document.head.appendChild(linkTag);
    }

    linkTag.href = `../themes/${theme}.css`;
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

/**
 * Hook para consumir o tema atual e trocar dinamicamente.
 *
 * @returns {{ theme: string, setTheme: (newTheme: string) => void }}
 */
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
